import { OnbOptionType } from '@/pages/Onboarding/types';

import { LayoutDataType } from '../../types';

export const ETHNICITY_OPTIONS: OnbOptionType<LayoutDataType['ethnicity']>[] = [
  {
    id: 'african',
    title: 'African',
  },
  {
    id: 'asian',
    title: 'Asian',
  },
  {
    id: 'european',
    title: 'European',
  },
  {
    id: 'latino',
    title: 'Latino',
  },
];
